import { u as useRecordVisibilityChanges, j as jsxRuntimeExports } from "./doenetml-jBZLIepG.js";
import React__default, { useRef } from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-TOMteQ16.js";
import { a as addCommasForCompositeRanges } from "./composites-D95_DyEz.js";
const blockQuote = React__default.memo(function Container(props) {
  let { id, SVs, children, actions, callAction } = useDoenetRenderer(props);
  const ref = useRef(null);
  useRecordVisibilityChanges(ref, callAction, actions);
  if (SVs.hidden) {
    return null;
  }
  if (SVs._compositeReplacementActiveRange) {
    children = addCommasForCompositeRanges({
      children,
      compositeReplacementActiveRange: SVs._compositeReplacementActiveRange,
      startInd: 0,
      endInd: children.length - 1
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("blockquote", { id, ref, children });
});
export {
  blockQuote as default
};
